(function () {
  'use strict';

  var FADE_DURATION     = 500;
  var FADE_EASING       = 'linear';
  var AUTOPLAY_INTERVAL = 5000;

  function initSaunaSection(section) {
    if (!section || section.dataset.saunaReady === 'true') return;
    section.dataset.saunaReady = 'true';

    var saunaSlides = section.querySelectorAll('.sauna-slide');
    var saunaDots   = section.querySelectorAll('.sauna-section__dot');
    var saunaMedia  = section.querySelector('.sauna-section__media');
    var saunaTitle  = section.querySelector('[data-sauna-title]');
    var prevBtn     = section.querySelector('[data-sauna-prev]');
    var nextBtn     = section.querySelector('[data-sauna-next]');

    if (!saunaSlides.length) return;

    var currentIndex = 0;
    var autoSlideInterval = null;
    var resumeTimeout = null;
    var isTransitioning = false;
    var layerA, layerB, activeLayer;

    if (saunaMedia) {
      var computedPosition = window.getComputedStyle(saunaMedia).position;
      if (computedPosition === 'static') {
        saunaMedia.style.position = 'relative';
      }

      layerA = document.createElement('div');
      layerB = document.createElement('div');

      [layerA, layerB].forEach(function (layer) {
        layer.style.position = 'absolute';
        layer.style.top = '0';
        layer.style.left = '0';
        layer.style.right = '0';
        layer.style.bottom = '0';
        layer.style.backgroundSize = 'cover';
        layer.style.backgroundPosition = 'center';
        layer.style.backgroundRepeat = 'no-repeat';
        layer.style.transition = 'opacity ' + FADE_DURATION + 'ms ' + FADE_EASING;
        saunaMedia.appendChild(layer);
      });

      layerA.style.opacity = '1';
      layerB.style.opacity = '0';
      activeLayer = layerA;
      saunaMedia.style.backgroundImage = 'none';
    }

    function setMediaImage(img, animate) {
      if (!saunaMedia || !img) return;

      var incomingLayer = activeLayer === layerA ? layerB : layerA;
      incomingLayer.style.backgroundImage = 'url(' + img + ')';

      if (!animate) {
        layerA.style.transition = 'none';
        layerB.style.transition = 'none';
        incomingLayer.style.opacity = '1';
        activeLayer.style.opacity = '0';
        void incomingLayer.offsetWidth;
        layerA.style.transition = 'opacity ' + FADE_DURATION + 'ms ' + FADE_EASING;
        layerB.style.transition = 'opacity ' + FADE_DURATION + 'ms ' + FADE_EASING;
        activeLayer = incomingLayer;
        return;
      }

      incomingLayer.style.opacity = '1';
      activeLayer.style.opacity = '0';
      activeLayer = incomingLayer;
    }

    function setTitle(text) {
      if (!saunaTitle) return;
      if (text && text.trim() !== '') {
        saunaTitle.textContent = text;
        saunaTitle.style.display = '';
      } else {
        saunaTitle.style.display = 'none';
      }
    }

    function goToSlide(index, animate) {
      if (animate === undefined) animate = true;
      if (isTransitioning) return;
      if (index < 0) index = saunaSlides.length - 1;
      if (index >= saunaSlides.length) index = 0;
      if (index === currentIndex && saunaSlides[index].classList.contains('is-active')) return;

      isTransitioning = true;

      var incomingSlide = saunaSlides[index];
      var img = incomingSlide.dataset.image;
      var title = incomingSlide.dataset.title;

      saunaSlides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      saunaDots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      incomingSlide.classList.add('is-active');
      if (saunaDots[index]) saunaDots[index].classList.add('is-active');

      setMediaImage(img, animate);
      setTitle(title);
      currentIndex = index;

      setTimeout(function () {
        isTransitioning = false;
      }, animate ? FADE_DURATION : 0);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
      }
      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }
    }

    function startAutoSlide(interval) {
      if (interval === undefined) interval = AUTOPLAY_INTERVAL;
      stopAutoSlide();
      autoSlideInterval = setInterval(nextSlide, interval);
    }

    function pauseAndResume() {
      stopAutoSlide();
      resumeTimeout = setTimeout(function () {
        resumeTimeout = null;
        startAutoSlide();
      }, 5000);
    }

    saunaDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(Number(dot.dataset.slide));
        pauseAndResume();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide();
        pauseAndResume();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide();
        pauseAndResume();
      });
    }

    // Initialize first slide
    saunaSlides[0].classList.add('is-active');
    if (saunaDots[0]) saunaDots[0].classList.add('is-active');
    if (saunaMedia && saunaSlides[0].dataset.image) {
      setMediaImage(saunaSlides[0].dataset.image, false);
    }
    setTitle(saunaSlides[0].dataset.title);
    startAutoSlide();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.sauna-section[data-section-id]').forEach(initSaunaSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    var section = block.closest('.sauna-section[data-section-id]');
    if (!section) return;

    var index = block.getAttribute('data-slide-content');
    if (index === null) return;

    var slides = section.querySelectorAll('.sauna-slide');
    var dots = section.querySelectorAll('.sauna-section__dot');
    var media = section.querySelector('.sauna-section__media');
    var title = section.querySelector('[data-sauna-title]');
    var i = parseInt(index, 10);

    slides.forEach(function (slide, n) {
      slide.classList.toggle('is-active', n === i);
    });

    dots.forEach(function (dot, n) {
      dot.classList.toggle('is-active', n === i);
    });

    var image = block.getAttribute('data-image') || '';
    var slideTitle = block.getAttribute('data-title') || '';

    if (media && image) {
      var layers = media.querySelectorAll('div');
      if (layers.length) {
        layers[0].style.backgroundImage = 'url(' + image + ')';
      } else {
        media.style.backgroundImage = 'url(' + image + ')';
      }
    }

    if (title) {
      title.textContent = slideTitle;
      title.style.display = slideTitle ? '' : 'none';
    }
  });
})();